module.exports = __webpack_public_path__ + "static/15-f0338052b451a24ae942fe9dc8a9fa2d.jpg";